import Vue from "vue";
import Router from "vue-router";
import Inicio from "@/components/pages/Inicio.vue";


Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "inicio",
      component: Inicio
    },
    {
      path: "/signup",
      name: "signup1",
      component: () => import("@/components/pages/New-user.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/components/pages/User-profile.vue")
    },
    {
      //sub menu de usuario
      path: "/user",
      //name:'user',
      component: () => import("@/components/pages/User-profile.vue"),
      children: [
        {
          path: "",
          // name: 'edit-profile',
          component: () => import("@/components/layouts/users/User-main.vue")
        },
        {
          path: "edit-profile",
          name: "edit-profile-direct",
          component: () => import("@/components/layouts/users/User-edit.vue")
        },
        {
          path: "dogs",
          name: "dogs",
          component: () => import("@/components/layouts/dogs/Dogs-main.vue")
        },
        {
          path: "inscriptions",
          name: "inscriptions",
         component: () =>
            import("@/components/layouts/inscriptions/Inscription-new.vue")
        },
        {
          path: "user-validate-email/:token",
          name: "user-validate-email",
          component:() => 
          import("@/components/layouts/users/User-Validate-Email.vue")
        },
        {
          path: "payments"
        },
        {
          path: "documents"
        },
        {
          path: "races"
        },
        {
          path: "dorsals"
        },
        {
          path: "catalogues"
        },
        {
          path: "contact"
        },
        {
          path: "exit"
        } /*,
            {
              path: '*',              
              component: () => import('@/components/pages/Inicio.vue')
            }  */
      ]
    },
    {
      path: "*",
      name: "/",
      component: () => import("@/components/pages/Inicio.vue")
    } /*
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/About.vue')
    }*/
  ]
});
/* 
router.beforeEach((to, from, next) => {
  setTimeout(() => next(), 10);
}); */

/* router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})
 */
router.beforeEach((to, from, next) => {
  // Set loading state
  //document.body.classList.add('app-loading')  

  let authRequired = false;
  const privatePages = ['user'];  
  privatePages.forEach( e =>  to.path.includes(e) ?  authRequired = true : false);
  const loggedIn = localStorage.getItem('user');
 


  if (authRequired && !loggedIn) {    
    return next('/login');
  }

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router;
